/**
 * @GENERATED from Figma node 3638:51959
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const LinkBright = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#7F776F"
      d="m18.747 2.861-.355-.354a5.16 5.16 0 0 0-7.286 0l-3.79 3.79a5.16 5.16 0 0 0 0 7.287l.355.354a5.13 5.13 0 0 0 6.054.9l.046-.046a1.086 1.086 0 0 0 0-1.457 1.8 1.8 0 0 0-.643-.55 3.09 3.09 0 0 1-4-.303l-.355-.354a3.095 3.095 0 0 1 0-4.373l3.79-3.794a3.096 3.096 0 0 1 4.372 0l.355.354a3.09 3.09 0 0 1 .251 4.064c.082.075.168.146.248.225l.355.355q.443.446.804.962a5.153 5.153 0 0 0-.201-7.06"
    />
    <path
      fill="#7F776F"
      d="M16.33 10.064a5.16 5.16 0 0 0-6.04-.915l-.06.06a1.03 1.03 0 0 0 0 1.458l.354.354a1 1 0 0 0 .29.196 3.07 3.07 0 0 1 3.999.303l.354.355a3.096 3.096 0 0 1 0 4.372l-3.788 3.792a3.096 3.096 0 0 1-4.372 0l-.355-.354a3.086 3.086 0 0 1-.251-4.065c-.083-.075-.169-.145-.249-.224l-.354-.355a7 7 0 0 1-.803-.967 5.153 5.153 0 0 0 .2 7.065l.354.354a5.16 5.16 0 0 0 7.287 0l3.79-3.79a5.16 5.16 0 0 0 0-7.287z"
    />
  </svg>
);
const ForwardRef = React.forwardRef(LinkBright);
export { ForwardRef as LinkBright };
